<template>
  <!-- 选择学习班  -->
  <div class="SchedulingLocationAndDatePanel">
    <div class="form_box location_container">
      <div class="form_box__group__item">
        <div class="form_box__group__item__title"><p class="text-medium">选择排课日期：</p></div>
        <div class="form_box__group__item__content ml-10">
          <!-- 选择日期 -->
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div class="form_box__group__item__tool"></div>
      </div>

      <div class="form_box__group__item">
        <div class="form_box__group__item__title"><p class="text-medium">选择时段：</p></div>
        <div class="form_box__group__item__content ml-10">
          <template v-if="checkingTimeAvailable">
            <div class="grey-3">
              <i class="el-icon-loading"></i> 检查时段是否可选择....
            </div>
          </template>
          <template v-else>
            <el-radio-group v-model="timetype">
              <el-radio-button
                :disabled="timeTypeMorningIsDisable"
                :label="0"
                >上午</el-radio-button
              >
              <el-radio-button
                :disabled="timeTypeAfternoonIsDisable"
                :label="1"
                >下午</el-radio-button
              >
              <el-radio-button
                :disabled="timeTypeNightIsDisable"
                :label="2"
                >晚上</el-radio-button
              >
            </el-radio-group>
          </template>
        </div>
        <div class="form_box__group__item__tool"></div>
      </div>

      <schedulinglocation ref="schedulinglocationRef" @onDataChanged="onLocationChanged"></schedulinglocation>


      <template v-if="isEdit">
        <div class="ml-2">
          <el-button @click="onClickUpdate" type="primary" :loading="loading">更新</el-button>
        </div>
      </template>
      <template v-else>
        <div style="padding-top: 20px; padding-bottom: 20px; padding-left: 20px; z-index: 200;">
          <el-button @click="onClickPrevious">上一步</el-button>
          <el-button type="primary" @click="onClickNext">下一步</el-button>
        </div>
      </template>


    </div>

    
    <!-- <template v-if="editMode">
      <div class="mt-5 ml-2">
        <el-button type="primary" :loading="loading" @click="doUpdate"
          >更新</el-button
        >
      </div>
    </template> -->
  </div>
</template>




<script>

import schedulinglocation  from "@/views/module/start/comp/schedulinglocation";
import { schedulingEditInitApi,schedulingEditDateAndlocationApi } from "@/api/module/scheduling/scheduling"

export default {
  name: "SchedulingLocationAndDatePanel",
  components: {
    schedulinglocation
  },
  data() {
    return {
      // edit scope
      id : null,
      loading : false,
      // edit scope end

      timeTypeMorningIsDisable : false,
      timeTypeAfternoonIsDisable : false,
      timeTypeNightIsDisable : false,
      checkingTimeAvailable : false,

      date : null, // 排课日期
      timetype :0 ,
      // gpsoffsetlevel : 0,

      address: {
      },

      addresses: [],

      formdata : {
        date : "",
        timetype : 0,
        addresses: []
      }
    };
  },
  methods:{

    initStart(){
      this.initComponent();
    },

    async init(){
      console.log("SchedulingLocationAndDatePanelRef",this.$route.path)

      if(this.$route.path != '/schedulingstart'){
        console.log("11111")
        await this.initComponent();

        await this.initDataById();
      }

      else {
        this.initDataById();
      }

    },


    async initDataById(){ 
      console.log("initDataById",1)
      await this.initComponent();

      let id = this.$route.query.id;

      if(id){
        this.id = id;

        console.log("initDataById",2)

        var resp = await schedulingEditInitApi(id);
        console.log("initDataById",3)

        this.addresses = resp.addresses;
        this.timetype = resp.timetype;
        this.date = resp.date;
        this.$refs.schedulinglocationRef.setAddresses(resp.addresses)
        console.log("initDataById",4)

      }
    },

    async initComponent(){
      setTimeout(() => {
            this.$refs.schedulinglocationRef.init();
      }, 100);
    },
    getOffsetLevelStr(item){
      if(item == 0){
        return "普通"
      }
      if(item == 1){
        return "小"
      }
      if(item == 2){
        return "大"
      }
      if(item == 1){
        return "超大"
      }
      return "无"
    },

    onLocationChanged(val){
      console.log("onLocationChanged",val)
      this.addresses = val;

    },

    onClickUpdate(){
      this.loading = true;
      this.$message.info("更新中")

      schedulingEditDateAndlocationApi(this.id,this.date,this.timetype,this.addresses)
        .then((r)=>{

          this.$message.success("更新成功")
          this.init();
        })
        .finally(()=>{
          this.loading = false;
        })

    },

    onClickNext(){

      this.formdata.date = this.date;
      this.formdata.timetype = this.timetype;
      this.formdata.addresses = this.addresses;

      if(!this.date){
        this.$message.error("未选择日期");
        return;
      }

      if(this.timetype == null){
        this.$message.error("请选择时段");
        return;
      }

      if(this.formdata.addresses == null 
        || this.formdata.addresses.length == 0
      ){
        this.$message.error("未填写地址信息");
        return;
      }

      // console.log("onClickNext",this.formdata)

      this.$emit('onClickNext',this.formdata)
    },

    onClickPrevious(){
      this.$emit('onClickPrevious',this.formdata)
    }
  },
  computed:{
    isEdit(){
      return this.id != null;
    }
  },
  watch:{
    location(oldVal,newVal){

    }
  },
  created() {

  },
  mounted(){
    // this.init();
  }
};
</script>

<style scoped>
.dimension {
  position: absolute;
  top: 10px;
  left: 610px;
}
.dimension div {
  white-space: nowrap;
  font-size: 13px;
}

.input__location {
  width: 500px;
}

.location_container{
  display: flex;
  flex-direction: column;
}
</style>